// import axios from "axios";

export default {
  state: () => ({
    showAgrement: false,
    saleID: "",
    // The sale the agreement modal is opened for, set by whoever opens it
    // (sales board card, sale tabs, onboarding).
    sale: null,
    orderID: "",
    showModal: false,
    isOnlyCard: false,
    imagePath: "",
    showBillingProductAgreement: false,
    billingProductIsAgreed: false,
    billingProducts: [],
  }),
  getters: {
    getShowModalState: (state) => {
      return state.showModal;
    },
  },
  mutations: {
    setSale(state, data) {
      state.sale = data;
    },
    setIsOnlyCard(state, data) {
      state.isOnlyCard = data;
    },
    setBillingProduct(state, data) {
      state.billingProducts = data;
    },
    setBillingProductIsAgreed(state, data) {
      state.billingProductIsAgreed = data;
    },
    setShowBillingProductAgreement(state, data) {
      state.showBillingProductAgreement = data;
    },
    setImagePath(state, data) {
      state.imagePath = data;
    },
    toggleShowModal(state) {
      state.showModal = !state.showModal;
    },
    setShowAgreement(state, data) {
      state.showAgrement = data;
    },
    setSaleID(state, data) {
      state.saleID = data;
    },
  },
  actions: {
    toggleShowAgreement({ state, commit }) {
      commit("setShowAgreement", !state.showAgrement);
    },
  },
  namespaced: true,
};
